import { useRouter } from 'next/router';

import Subheading from 'components/Subheading';
import EmailValidationMessage from 'components/enter/EmailValidationMessage';
import { EntryMethodDetails } from 'components/enter/EntryMethod';
import { PageState } from 'components/enter/PageContent';
import PaymentSection from 'components/enter/PaymentSection';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { ValueOf } from 'next/dist/shared/lib/constants';
import { ASSET_PREFIX } from 'utils/constants';

interface IPaymentAndUpsellSection {
  pageState: ValueOf<typeof PageState>;
}
const PaymentAndUpsellSection = observer(
  ({ pageState }: IPaymentAndUpsellSection) => {
    const { entryMethod } = useEnterStore();

    const router = useRouter();
    const { currentUser } = useUserStore();

    const HIDE_POUND_RAFFLE_UPSELL = true;
    return (
      <div className="paymentAndUpsellSection paddedMaxWidthContainer">
        <Subheading
          underlineColor={
            entryMethod
              ? EntryMethodDetails[entryMethod].underlineGlowColor
              : '#95F5DE'
          }
          id="youMightAlsoLikeSection"
        >
          <div className="!normal-case">Payment</div>
        </Subheading>

        <img src={`${ASSET_PREFIX}/static/trust_pilot.svg`} />
        {pageState === PageState.PAYING && (
          <EmailValidationMessage
            style={{
              margin: '0.3em 0 1em',
            }}
          />
        )}
        <PaymentSection />
        <style jsx>
          {`
            .paymentAndUpsellSection {
              max-width: 450px;
              margin: 2em auto;
            }

            .textCheckboxContainer {
              max-width: 450px;
            }

            :global(.paymentAndUpsellSection .boostJackpotSection) {
              width: auto;
              margin: 1em 0;
              padding: 3em 6%;
            }

            :global(.paymentAndUpsellSection .infoIcon) {
              position: absolute;
              margin-left: 3px;
              padding: 3px;
              width: 21px;
              cursor: pointer;
            }
          `}
        </style>
      </div>
    );
  }
);

export default PaymentAndUpsellSection;
